<template>
    <div class="d-flex flex-column flex-wrap">
        <div class="ppv2-flex ppv2-items-center ppv2-justify-between">
            <h2
                class="poppinsRegular ppv2-text-black"
                :class="customClass"
                :style="{ fontSize: normalizeFontSize(customFontSize) }"
            >
                {{ title }}
                <p v-if="subtitle" class="ppv2-text-black poppinsRegular ppv2-italic mb-0 ppv2-text-sm">{{ subtitle }}</p>
            </h2>
        </div>
    </div>
</template>
<script>
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: '',
        },
        customFontSize: {
            type: Number,
            default: 26,
        },
        customClass: {
            type: String,
            default: '',
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>
